import { TablePagination } from '@mui/material';
import { useState } from 'react';

/** The one set of page sizes for every table in the app. */
export const TABLE_PAGE_SIZES = [25, 50, 100];
export const DEFAULT_PAGE_SIZE = TABLE_PAGE_SIZES[0];

export interface TablePage {
  /** Zero based, as the pager counts. */
  page: number;
  pageSize: number;
  /** Ready to spread into a list query. */
  params: { page: number; page_size: number };
  setPage: (page: number) => void;
  setPageSize: (size: number) => void;
}

/** Which page of a table is showing. Call `setPage(0)` when a search or filter changes. */
export function useTablePage(): TablePage {
  const [page, setPage] = useState(0);
  const [pageSize, setSize] = useState(DEFAULT_PAGE_SIZE);
  return {
    page,
    pageSize,
    params: { page: page + 1, page_size: pageSize },
    setPage,
    setPageSize: (size) => {
      setSize(size);
      setPage(0);
    },
  };
}

/** Hidden when everything fits on the smallest page. */
export function TablePager({ paging, total }: { paging: TablePage; total: number }) {
  if (total <= DEFAULT_PAGE_SIZE) return null;
  return (
    <TablePagination
      component="div"
      count={total}
      page={paging.page}
      rowsPerPage={paging.pageSize}
      rowsPerPageOptions={TABLE_PAGE_SIZES}
      onPageChange={(_, next) => paging.setPage(next)}
      onRowsPerPageChange={(e) => paging.setPageSize(Number(e.target.value))}
    />
  );
}
